import { call, fork, take } from 'redux-saga/effects';

// Restarts a watcher when an uncaught error escapes from it (or from a worker
// it forked), so one failing request can't kill that watcher for good.
export const keepAlive = (saga) =>
  function* keepAliveSaga(...args) {
    while (true) {
      try {
        yield call(saga, ...args);
        return;
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(`Saga ${saga.name || 'anonymous'} crashed, restarting:`, error);
        }
      }
    }
  };

// Like takeLeading, but per key: ignores repeats for the same key while its
// request is in flight, without dropping actions for other keys (e.g. other products).
export const takeLeadingPerKey = (pattern, getKey, worker) =>
  fork(function* () {
    const inFlight = new Set();
    while (true) {
      const action = yield take(pattern);
      const key = getKey(action);
      if (inFlight.has(key)) continue;
      inFlight.add(key);
      yield fork(function* () {
        try {
          yield call(worker, action);
        } finally {
          inFlight.delete(key);
        }
      });
    }
  });
